import { Grid } from '@mui/material';
import { usePageTitle } from '@hooks/usePageTitle';
import { Header } from '@layouts/Base/components/Header';
import { ResponsesTable } from '@area/responses/components/ResponsesTable';

export const ResponsesPage = () => {
  usePageTitle('Отклики');

  return (
    <Grid container direction="column" gap="24px">
      <Grid item>
        <Header title="Отклики" />
      </Grid>
      <ResponsesTable />
    </Grid>
  );
};
